<!--
 * @Description: 
 * @Author: yangyang
 * @Date: 2023-05-25 13:45:23
 * @LastEditTime: 2024-05-13 15:24:07
 * @LastEditors: yangyang
-->
<template>
  <navself class="bread-nav">
    <ul class="nav-items fs-14">
      <li
        class="in-block p-20 hover nav-item pad-b-5"
        :class="{ active: activeIndex == item.id }"
        v-for="(item, index) in getNavList"
        :key="index"
        @click="checkSM(item, index)"
      >
        {{ item.label }}
      </li>
    </ul>
  </navself>
</template>
<script>
import Nav from "./Nav";
import { deepCopy } from "@/common/js/utils";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "BreadNav",
  components: {
    navself: Nav
  },
  props: {},
  data() {
    return {
      activeNav: {}
    };
  },
  computed: {
    getNavList() {
      let id = this.$route.query.id;
      let nav = this.getMenuOptions.filter(item => {
        return item.id == id;
      })[0];
      this.activeNav = nav || {};
      return nav ? nav.items : [];
    },
    activeIndex() {
      return this.$route.query.sid;
    },
    ...mapGetters(["getMenuOptions"])
  },
  methods: {
    checkSM(item, index) {
      const list = [1, 2, 3, 5];
      let query = deepCopy(this.$route.query);
      query.sid = item.id;
      // query.aid = list.includes(query.id)?1
      // if(list.includes(query.id)){
      //   query.aid = 1
      // }else{
      //   delete query.aid
      // }
      this.$router.push({ name: this.$route.name, query });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../common/css/variable.less);
.bread-nav {
  background-color: #293042;
  .m-t-40 {
    margin-top: 0.4rem;
  }
  .p-20 {
    padding: 20px;
  }
  .nav-items {
    .nav-item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: #fff;
      &.active,
      &:hover {
        background: rgba(239, 239, 239, 0.1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/BreadNav.vue